<template>
    <v-dialog v-model="getAddFaq" width="55%" height="55%" persistent>
        <v-card>
            <v-card-title>Add Faq </v-card-title>
            <v-divider></v-divider>
            <v-alert color="info" class="ma-2 white--text" type="info">
                1) Spanish Version will be added by Advanced Robot Solutions. <br />
                2) Please check if the FAQ already exists in the system. </v-alert>
            <v-row no-gutters class="mx-5 mt-5">
                <v-col cols="3">
                    <v-text-field label="Link ID" outlined disabled v-model="faqDetails.linkId"
                        class="mx-2"></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-select :items="getFaqCategory" item-text="categoryName" item-value="categoryName"
                        v-model="faqDetails.category" label="Category" class="mx-2"></v-select>
                </v-col>
            </v-row>
            <v-row no-gutters class="mx-5">
                <v-col cols="4">
                    <v-textarea v-model="faqDetails.question" label="Question" class="ma-2 mr-4" outlined></v-textarea>
                </v-col>
                <v-col cols="8">
                    <v-textarea v-model="faqDetails.answer" label="Answer" class="ma-2 ml-4" outlined></v-textarea>
                </v-col>
            </v-row>
            <v-row no-gutters class="mx-5">
                <v-col cols="2">
                    <v-switch v-model="faqDetails.showmap" label="Show Map" class="mx-2"></v-switch>
                </v-col>
                <v-col cols="4">
                    <v-select :items="getMaps" item-text="mapName" item-value="mapName" v-model="faqDetails.mapName"
                        label="Map Name" outlined :disabled="!faqDetails.showmap"></v-select>
                </v-col>
            </v-row>
            <v-row no-gutters class="mx-5">
                <v-col cols="2">
                    <v-switch v-model="faqDetails.showUrl" label="Show QR" class="mx-2"></v-switch>
                </v-col>
                <v-col cols="4">
                    <v-textarea v-model="faqDetails.urlDetails" label="QR Code info" outlined
                        :disabled="!faqDetails.showUrl"></v-textarea>
                </v-col>
                <v-col cols="4" class="ml-4">
                    Ex. <br>
                    <span>{"urlist":[ { "name": "Button Name", "link":"Link to website", "desc": "Description of the
                        link."}]}</span>
                </v-col>
            </v-row>
            <v-card-actions class="justify-end">
                <span></span>
                <v-btn width="100" class="ma-3" color="primary" @click="addFaq()" :loading="loading"><v-icon
                        class="mr-2" small>mdi-plus</v-icon>Add</v-btn>
                <v-btn width="100" class="ma-3" @click="closeFaq()" color="grey"><v-icon class="mr-2"
                        small>mdi-close</v-icon> Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    name: "viewFaqs",
    data() {
        return {
            faqDetails: {
                question: '',
                answer: '',
                category: '',
                showmap: false,
                mapName: '',
                showUrl: false,
                urlDetails: '',
                linkId: 0,
                courtLocationCode: 'WM'
            },
            loading: false
        }
    },
    computed: {
        ...mapGetters(['getAddFaq', 'getFaqCategory', 'getMaps', 'getFaqs', 'snackBar', 'userProfile', 'isSuperAdmin', 'isClientAdmin', 'isAdmin'])
    },
    watch: {
        getAddFaq(newVal) {
            if (newVal) {
                let tempFaqs = this.getFaqs.sort((a, b) => { return a.linkId - b.linkId })
                this.faqDetails.linkId = tempFaqs[tempFaqs.length - 1].linkId + 1

            }
        },
        snackBar(newVal) {
            if (newVal.show) {
                this.closeFaq();
            }
        }
    },
    methods: {
        closeFaq() {
            this.loading = false
            this.faqDetails = {
                question: '',
                answer: '',
                category: '',
                showmap: false,
                mapName: '',
                showUrl: false,
                urlDetails: null,
                linkId: 0,
                courtLocationCode: 'WM'
            }
            this.$store.commit('setAddFaq', false);

        },
        addFaq() {
            this.loading = true
            this.$store.dispatch('createIndex', this.faqDetails)
        }
    },
}
</script>